import { render, staticRenderFns } from "./card-hotel.vue?vue&type=template&id=4bfeb8dc&"
import script from "./card-hotel.vue?vue&type=script&lang=js&"
export * from "./card-hotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports